import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ArtlistDataContext from '@/context/ArtlistDataContext';
import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import UserService from '@/services/user.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/DeleteArtlist.css';

export default function DeleteArtlist({ open, close }) {
  const { stateHandler, cacheHandler } = useStateHandler();
  const { artlistData } = useContext(ArtlistDataContext);
  const t = useTranslations('common.profile.pages.artlist');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function deleteArtlist() {
    setLoading(true);

    const { response } = await UserService.deleteArtlist(artlistData._id);

    if (response.ok) {
      stateHandler.set("temporalPopup", { 
        text: t('temporal.artlist_deleted'), 
        type: "navbar-present"
      });
      cacheHandler.triggerAction("DELETE_ARTLIST");
      navigate("/profile/artlists", { replace: true });
    }
  }

  const onCloseClick = () => {
    if (!loading) {
      close();
    }
  };

  return (
    <GenericPopup open={open} className="delete-artlist-popup" opacity>
      <div className="delete-artlist-popup__container">
        <div className="delete-artlist-popup__header">
          <h3 className="delete-artlist-popup__header-text">
            {t('delete_popup.title')}
          </h3>
          <XIcon className="delete-artlist-popup__close" onClick={onCloseClick} />
        </div>

        <Text className="delete-artlist-popup__text">
          {t('delete_popup.description')}
        </Text>

        <div className="delete-artlist-popup__buttons">
          <ContinueButton onClick={onCloseClick} className="continue-button_two">
            {t('delete_popup.actions.keep_it')}
          </ContinueButton>
          <ContinueButton onClick={deleteArtlist} className="continue-button_two">
            {t('delete_popup.actions.delete')}
          </ContinueButton>
        </div>
      </div>
    </GenericPopup>
  );
}
